import { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { SingleOrientationFilter } from '~/components/Filters/OrientationFilter/SingleOrientationFilter';
import { FilterTrigger } from '~/components/Filters/SingleFilters/FilterTrigger';
import { type SingleFilterProps } from '~/components/Filters/types';
import { baseFiltersOptions } from '~/components/FiltersMenu/types';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { removeFilterAction } from '~/store/filters/actions';
import { type SelectedFilter } from '~/store/filters/types';

export const OrientationFilterTrigger = memo(({ onApplyClick, onRemoveClick, onOpenChange }: SingleFilterProps) => {
  const dispatch = useDispatch();
  const { orientationsParam } = useFilterParams();

  const content = useMemo(() => <SingleOrientationFilter onApplyClick={onApplyClick} />, [onApplyClick]);

  const appliedOrientationsCount = orientationsParam?.or?.length ?? (orientationsParam?.is ? 1 : 0);

  const removeFilter = useCallback(() => {
    const filter: SelectedFilter = { type: 'orientation' };
    dispatch(removeFilterAction({ filter }));
    onRemoveClick?.([filter]);
  }, [dispatch, onRemoveClick]);

  return (
    <FilterTrigger
      onRemoveClick={removeFilter}
      count={appliedOrientationsCount}
      filterContent={content}
      title={baseFiltersOptions['orientation'].label}
      Icon={baseFiltersOptions['orientation'].icon}
      onOpenChange={onOpenChange}
    />
  );
});

OrientationFilterTrigger.displayName = 'OrientationFilterTrigger';
